import {
    REQUEST_ACCOUNT_GAINS,
    RECEIVE_ACCOUNT_GAINS,
    FAILURE_ACCOUNT_GAINS
} from './constants';
import { CALL_API } from '../../../middlewares/api';

export function fetchAccountGains() {
    return {
        [CALL_API]: {
            endpoint: '/user/gains',
            types: [REQUEST_ACCOUNT_GAINS, RECEIVE_ACCOUNT_GAINS, FAILURE_ACCOUNT_GAINS]
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/account/gains/actions.js